import {
  EstateImprovement,
  EstateSubscription,
} from "@1games-ru/region-shared/dist/enums/estate/estate";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import ImprovementInfoWrapper from "@/shared/widgets/ImprovementInfoWrapper";

type Props = {
  type: EstateImprovement | EstateSubscription;
  icon: (props: { className?: string }) => JSX.Element;
  children: ReactNode;
};

function EstateImprovementWrapper({ type, icon, children }: Props) {
  const { t } = useTranslation("estate");

  const description = type ? t(`estate.improvements.types.${type}.description`) : "";

  return (
    <ImprovementInfoWrapper description={description} icon={icon}>
      {children}
    </ImprovementInfoWrapper>
  );
}

export default EstateImprovementWrapper;
